export const WEBSITEBUILDERVIEW = 'WEBSITEBUILDERVIEW';
export const WEBSITEBUILDERDATA='WEBSITEBUILDERDATA'
export const RESETWEBSITEBUILDERDATA='RESETWEBSITEBUILDERDATA'

